import EcocarotidiEdit from "./components/EcocarotidiEdit.vue";
import EcocarotidiView from "./components/EcocarotidiView.vue";
import EcocarotidiList from "./components/EcocarotidiList.vue";

export default {
    EcocarotidiEdit,
    EcocarotidiView,
    EcocarotidiList,
};
